import {FlashCardInterface} from 'fuse-core/components/flashcard/flash-card.interface';

export interface FlashCardsContent {
    flashcards: FlashCardInterface[];
}